export { default } from "./LicenseInactive";
